import {ApiService} from '../../index';

export const getRejectedList = (sample_id: string) => {
    return ApiService.baseAction(
        `rejected-sample/${sample_id}/list`,
        {},
        'get'
    )
}